import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material'
import { Outlet, useNavigate } from 'react-router-dom'
import ExamParticipantsTab from '../components/ExamParticipantsTab'

export default function ProctorLayout() {
   const navigate = useNavigate()
   const logout = () => {
      sessionStorage.removeItem('token')
      alert('logout!')
      navigate('/login')
   }

   return (
      <Box>
         <AppBar position="static">
            <Toolbar>
               <Typography variant="h6" sx={{ flexGrow: 1 }}>
                  SMP Terpadu Al-Qudwah
               </Typography>
               <Button color="inherit" variant="outlined" onClick={logout}>
                  Logout
               </Button>
            </Toolbar>
         </AppBar>
         <Box sx={{ p: 2 }}>
            <Outlet />
         </Box>
         <Box sx={{ m: 2 }}>
            <ExamParticipantsTab />
         </Box>
      </Box>
   )
}
